import {useIsFetching, useQueryClient} from '@tanstack/react-query';
import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {useTransactionsHistoryOptions} from '~/entities/transactions-history';
import {selectAssetsLoadingFlag} from '~/redux/assets/assetsSelectors';
import {selectBalancesLoadingFlag} from '~/redux/balances/balancesSelectors';
import {useAppDispatch} from '~/shared/store';
import {refreshHomePage} from '../../HomePage';

const selectIsRefreshing = (state: AppModel) => {
    return selectAssetsLoadingFlag(state) || selectBalancesLoadingFlag(state);
};

export function useHomeRefresh() {
    const dispatch = useAppDispatch();
    const txnsQueryKey = useTransactionsHistoryOptions().queryKey.slice(0, 1);

    const isStoreRefreshing = useSelector(selectIsRefreshing);
    const isTransactionsFetching = useIsFetching({queryKey: txnsQueryKey}) > 0;

    const isRefreshing = isStoreRefreshing || isTransactionsFetching;

    const qc = useQueryClient();
    const refresh = useCallback((): void => {
        dispatch(refreshHomePage());
        qc.invalidateQueries({queryKey: txnsQueryKey});
    }, []);

    return [refresh, isRefreshing] as const;
}
